// extracted by mini-css-extract-plugin
export var divider = "_hk-0";
export var systemMessage = "_hk-1";
export var systemMessageWrapper = "_hk-2";